import {
  Directive,
  Input,
  ViewContainerRef,
  ComponentRef,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  OnDestroy,
  Type,
} from '@angular/core';

@Directive({
  selector: '[appComponentHost]',
  standalone: true,
})
export class ComponentHostDirective<T> implements OnChanges, OnDestroy {
  private componentRef: ComponentRef<T> | null = null;

  @Input() component?: Type<T>;
  @Input() componentHidden?: boolean = false;
  @Output() instanceCreated = new EventEmitter<T>();

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['component']) {
      this.cleanup();
      this.loadComponent();
    }
  }

  ngOnDestroy(): void {
    this.cleanup();
  }

  private loadComponent(): void {
    if (this.component && !this.componentHidden) {
      this.componentRef = this.viewContainerRef.createComponent(
        this.component
      );
      this.instanceCreated.emit(this.componentRef.instance);
    }
  }

  private cleanup(): void {
    if (this.componentRef) {
      this.componentRef?.destroy();
      this.componentRef = null;
      this.viewContainerRef.clear();
    }
  }
}
